import { LoginPage } from '@a6tr/features/login/LoginPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const loginSearchSchema = z.object({
	return_to: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
	validateSearch: loginSearchSchema,
	component: RouteComponent,
});

function RouteComponent() {
	const { return_to } = Route.useSearch();
	return <LoginPage returnTo={return_to} googleOnly />;
}
